//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

export const SCHEDULER_POST_DETAILS_ROUTES = {
  FACEBOOK: '/facebook/schedule',
  INSTAGRAM: '/instagram/schedule/post-details',
  PINTEREST: '/pinterest/schedule/post-details',
  TIKTOK: '/tiktok/schedule/post-details',
  TWITTER: '/twitter/schedule/post-details',
  SCHEDULER: '/schedule/scheduler',
} as const;
